import axios from "axios";

export const api = axios.create({
  //baseURL: `http://localhost:5000`
  baseURL: "https://server-dot-local-cogency-323120.uc.r.appspot.com"
});
